import { Button } from 'primereact/button';

export function SubmitButton({ label, loading }: { label: string; loading: boolean }) {
  return (
    <Button
      className="auth-submit"
      type="submit"
      label={loading ? 'Please wait…' : label}
      loading={loading}
      disabled={loading}
    />
  );
}
